<template>
  <div class="v-register-step" :stepType='stepType'>
    <div v-for="item in step" :key="item.id" class="regStep align-center" :class="item.id == stepType ? 'registerCheck' : 'registerCheckn'">
        <!-- <div :class="item.id == stepType ? 'registerStepC' : 'registerStep'">{{item.content}}</div>
        <span class="iconfont iconright_sanjiao"></span> -->
        <template v-if="!(item.id ===  2 || item.id === 3) && type === 'mobile' || type !== 'mobile'">
            <div class="iconStep">
            <template v-if="item.id == stepType">
                <div class="iconfont iconcheck">{{item.id}}</div>
            </template>
            <template v-else-if="item.id < stepType">
                <i class="iconfont iconchenggongtishi check"/>
            </template>
            <template v-else-if="item.id > stepType">
                <div class="iconfont iconnocheck">{{item.id}}</div>
            </template>
            <template v-if="item.id == stepType">
                <span class="check checkWeight">{{item.content}}</span>
            </template>
            <template v-else-if="item.id < stepType">
                <span class="check">{{item.content}}</span>
            </template>
            <template v-else-if="item.id > stepType">
            <span class="nocheck">{{item.content}}</span>
            </template>
                
            </div>
            <template v-if="item.id == stepType">
            <div class="iconR iconRnocheck"></div>
            </template>
            <template v-else-if="item.id < stepType">
            <div class="iconR iconRcheck"></div>
            </template>
            <template v-else>
            <div class="iconR iconRnocheck"></div>
            </template>
        </template>
    </div>
 </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'vRegisterStep',
  props:['stepType', 'type'],
  data() {
    return {
      step:[
        {
          'id':1,
          'content': this.$t('Create Account')
        },
        {
          'id':2,
          'content': this.$t('Confirm Email')
        },
        {
          'id':3,
          'content': this.$t('Set Password')
        },
        {
          'id':4,
          'content': this.$t('Fill in info')
        },
        {
          'id':5,
          'content': this.$t('Questionnaire')
        },
        {
          'id':6,
          'content': this.$t('Completed')
        }

      ],
      stepId: 0,
    }
  },
  computed: {
    ...mapGetters(['language', 'loginAccount', 'subjectType'])
  },
  mounted() {},

  methods: {}
}
</script>
<style lang="stylus">
.v-register-step{
    display: flex;
    justify-content: center;
    text-align: center;
    margin:40px auto;
    font-size:14px
    .iconfont{
      width 8px;
      height 10px 
      margin: 11px 7px;
    }
}
.registerStep{
    padding 0px 15px
    height 32px
    width 130px
    border 1px solid $color-black-65
    border-radius: 4px;
    line-height 32px;
    text-align center;
}
.registerStepC{
  padding 0px 15px
  height 32px
  width 130px
  border 1px solid $color-main
  border-radius: 4px;
  line-height 32px;
  text-align center;
}
// .regStep:last-child{
//     .iconfont{
//       display none
//     }
// }
.registerCheck{
  color $color-main
  display flex
}
.registerCheckn{
  color $color-black-65
  display flex
}
.iconStep {
  display flex
  align-items center
}
.check{
  color $color-main
}
.nocheck {
  color $color-black-45
}
.checkWeight{
  font-weight bold
  color $color-black-85
}
.iconcheck{
  border 1px solid $color-main
  color $color-white
  background $color-main
  border-radius: 10px;
  width 20px !important
  height 20px !important
  display inline-block
}
.iconnocheck{
  border 1px solid $color-black-15
  color $color-black-25
  // background $color-black-65
  border-radius: 10px;
  width 20px !important
  height 20px !important
  display inline-block
  font-weight bold
}

.iconchenggongtishi{
  font-size 16px
  width 20px !important
  height 20px !important
  // margin-top 0 !important
}

.iconR{
  width 15px
  height 1px
  margin-left 7px
}
.iconRcheck{
  background $color-main
}

.iconRnocheck{
  background $color-black-65
}
.regStep:last-child{
  .iconR{
    display none
  }
}


</style>
